import React from 'react';

import ReportSearchForm from './ReportSearchForm';
import ReportSearchResult from './ReportSearchResult';

import Page from '../../common-components/Page';
import PaperContainer from '../../common-components/PaperContainer';
// import Typography from '@material-ui/core/Typography';

import * as strings from '../../helpers/strings';

const ReportSearchScreen = () => (
  <Page title={strings.lblErrorReports}>
    {/* <PaperContainer> */}
    {/* <Typography variant="h5" color={strings.colorPrimary} title={strings.lblErrorReportsTable}>{strings.lblErrorReportsTable}</Typography> */}
      <ReportSearchForm/>
      <ReportSearchResult/>
    {/* </PaperContainer> */}
  </Page>
);

export default ReportSearchScreen;